export const CATEGORY = 'CATEGORY'
export const PRODUCTS_SET = 'PRODUCTS_SET'
export const PRODUCTS_TYPE = 'PRODUCTS_TYPE'

export const all_types = [
    CATEGORY,
    PRODUCTS_SET,
    PRODUCTS_TYPE,
]

export const label = {
    [CATEGORY]: 'Категория',
    [PRODUCTS_SET]: 'Списки',
    [PRODUCTS_TYPE]: 'Типы товаров',
}
